import type { DuctedPanelSelection } from 'components/equipment-page/ducted-system-detail-panel';
import { useCallback, useState } from 'react';
import { withMappedComparedId } from 'utils/ducted-compare-state';

export const useDuctedCompareMap = () => {
  const [comparedIdByCardId, setComparedIdByCardId] = useState<
    ReadonlyMap<string, string>
  >(new Map());
  const [selectionBySystemId, setSelectionBySystemId] = useState<
    ReadonlyMap<string, DuctedPanelSelection>
  >(new Map());

  const mapComparedId = useCallback(
    (cardId: string, systemId: string, selection?: DuctedPanelSelection) => {
      setComparedIdByCardId((previous) =>
        withMappedComparedId(previous, cardId, systemId)
      );
      if (selection) {
        setSelectionBySystemId((previous) =>
          new Map(previous).set(systemId, selection)
        );
      }
    },
    []
  );

  return { comparedIdByCardId, selectionBySystemId, mapComparedId };
};
